// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';

// Internal Dependencies
import TrailItems from './TrailItems';
import apiService from '../../../../services.js/apiService';
import { TrailItemType, Url } from '../../../../common/constants';

const ReviewTrailItems = ({ match }) => {
  const { pageId, trailId } = match.params;

  return (
    <TrailItems
      match={match}
      type={TrailItemType.Review}
      linkedIdKey="reviewId"
      linkPathGen={(id) => Url.Review.replace(':pageId', pageId).replace(':reviewId', id)}
      onUpdateService={(reviewIds) => apiService.updateReviewTrailItems(pageId, trailId, { reviewIds })}
      onFetchTableData={(params) => apiService.getTrailItems(pageId, trailId, params)}
      onFetchLeftTransferList={(params) => apiService.getReviewsByParams({ ...params, pageId })}
      onFetchRightTransferList={() => apiService.getTrailItems(pageId, trailId, { type: TrailItemType.Review })}
    />
  );
};

ReviewTrailItems.propTypes = {
  match: PropTypes.shape(Object).isRequired,
};

export default ReviewTrailItems;
